"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeartFilled = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var HeartFilled = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M24 7.6A6.6 6.6 0 0017.4 1 7.632 7.632 0 0012 3.484 7.632 7.632 0 006.6 1 6.6 6.6 0 000 7.6c0 4.704 5.7 9.9 8.4 12.6l2.736 2.736a.9.9 0 00.636.264h.456a.9.9 0 00.636-.264L15.6 20.2c2.7-2.7 8.4-7.896 8.4-12.6z" })); };
exports.HeartFilled = HeartFilled;
//# sourceMappingURL=heart-filled.js.map